import type { ReactElement } from 'react';
import type { ExtensionSecuritySummary } from '@kirin/api-client/contracts/extensions';
import { getSeverityLabel } from '@kirin/api-client/helpers/severity';
import { SeverityBadge } from '@/components/policylist/components/SeverityBadge';

interface SecuritySummaryCellProps {
  /** Optional on list rows until enrichment runs; null = scanned with no findings. */
  summary: ExtensionSecuritySummary | undefined;
}

export function SecuritySummaryCell({
  summary,
}: SecuritySummaryCellProps): ReactElement {
  if (summary == null) {
    return (
      <span className="inline-flex items-center gap-1.5 text-muted-foreground">
        <span
          aria-hidden
          className="size-1.5 shrink-0 rounded-full bg-muted-foreground/50"
        />
        No findings
      </span>
    );
  }

  const severityLabel = getSeverityLabel(summary.severity);
  const label =
    summary.score === null
      ? severityLabel
      : `${severityLabel} - ${summary.score}`;

  return (
    <SeverityBadge
      riskLevel={summary.severity}
      label={label}
      showIcon={false}
    />
  );
}

SecuritySummaryCell.displayName = 'SecuritySummaryCell';
